<div class="full-width-wrapper">
  <div class="direct-apply-hero">
    <!-- Carousel Layer -->
    <div class="carousel-cylinder">
      <div class="carousel-item" *ngFor="let logo of extendedLogos; let i = index" 
           [ngStyle]="{'transform': 'rotateY(' + (i * 22.5) + 'deg) translateZ(-754px)'}">
        <div class="visible-area">
          <img [src]="logo" alt="University Logo" />
        </div>
      </div>
    </div>

    <!-- White Fade Mask Layer -->
    <div class="hero-overlay-fade"></div>

    <!-- Content Layer -->
    <div class="hero-content">
      <div class="badge">
        <div class="icon-wrapper">
          <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
         Direct Apply Open for {{ intakeYear }} intake
      </div>
      
      <h1>One application. {{partnerUniversitiesCount}}+ universities.<br><span class="highlight">Zero chaos.</span></h1>
      
      <p class="subtitle">
        Apply to {{partnerUniversitiesCount}}+ partner universities worldwide from a single, streamlined application. Our dedicated consultant reviews every detail so you don't have to stress about the paperwork.
      </p>
      
      <button class="primary-btn" (click)="showClarityPopup = true">
        Talk to a counsellor
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
      
      <div class="stats-row">
        <div class="avatar-group">
          <div class="avatar bg-purple">AR</div>
          <div class="avatar bg-green">KS</div>
          <div class="avatar bg-orange">PM</div>
          <div class="avatar bg-blue">RV</div>
          <div class="avatar bg-dark">+</div>
        </div>
        <div class="stats-text">
          <strong>100+ students admitted</strong><br>
          Across 15+ countries this academic year
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Roadmap Section -->
<div class="roadmap-section">
  <div class="roadmap-content">
    <h2 class="roadmap-title">Your roadmap from search to offer letter</h2>
    <p class="roadmap-subtitle">Six deliberate steps each one moves you closer to that acceptance letter, guided by our team the entire way.</p>
  </div>

  <!-- Cards Grid -->
  <div class="roadmap-cards-grid">
    <!-- Card 1 -->
    <div class="roadmap-card">
      <div class="rc-header">
        <div class="rc-icon">
          <img src="assets/images/icon-park-outline_list.svg" alt="Icon" />
        </div>
        <div class="rc-number">01</div>
      </div>
      <div class="rc-title">Build your hitlist</div>
      <div class="rc-text">Dive into College Discovery and find universities that match your vibe. Not sure where to start? Chat with us for shortlisting help.</div>
    </div>

    <!-- Card 2 -->
    <div class="roadmap-card">
      <div class="rc-header">
        <div class="rc-icon">
          <img src="assets/images/icon-park-outline_list.svg" alt="Icon" />
        </div>
        <div class="rc-number">02</div>
      </div>
      <div class="rc-title">Shortlist your colleges</div>
      <div class="rc-text">Save up to 5 colleges to My Colleges. Your final shortlist is saved, stacked, and ready to be applied to.</div>
    </div>

    <!-- Card 3 -->
    <div class="roadmap-card">
      <div class="rc-header">
        <div class="rc-icon">
          <img src="assets/images/game-icons_papers.svg" alt="Icon" />
        </div>
        <div class="rc-number">03</div>
      </div>
      <div class="rc-title">Smash the paperwork</div>
      <div class="rc-text">Open the application form, fill in your details. Don't stress about making it look polished — that's exactly what we're here for.</div>
    </div>

    <!-- Card 4 -->
    <div class="roadmap-card">
      <div class="rc-header">
        <div class="rc-icon">
          <img src="assets/images/streamline-sharp_customer-support-setting-solid.svg" alt="Icon" />
        </div>
        <div class="rc-number">04</div>
      </div>
      <div class="rc-title">Talk to an expert</div>
      <div class="rc-text">Still unsure about your choices? Connect with an expert counsellor to clear the confusion and sharpen your strategy before committing.</div>
    </div>

    <!-- Card 5 -->
    <div class="roadmap-card">
      <div class="rc-header">
        <div class="rc-icon">
          <img src="assets/images/handshake-icon.svg" alt="Icon" />
        </div>
        <div class="rc-number">05</div>
      </div>
      <div class="rc-title">Meet your co-pilot</div>
      <div class="rc-text">You're never flying solo. A dedicated consultant reviews your files, double-checks every detail, and helps you hit submit with confidence.</div>
    </div>

    <!-- Card 6 -->
    <div class="roadmap-card">
      <div class="rc-header">
        <div class="rc-icon">
          <img src="assets/images/streamline-ultimate_cash-payment-bills-bold.svg" alt="Icon" />
        </div>
        <div class="rc-number">06</div>
      </div>
      <div class="rc-title">Pay & manifest that offer</div>
      <div class="rc-text">Heavy lifting done. Review your cart, make payment, breathe. Keep your fingers crossed and wait for those acceptance letters to roll in.</div>
    </div>
  </div>

  <svg class="flight-path-svg" viewBox="0 0 1440 861" preserveAspectRatio="xMidYMid slice">
    <defs>
      <filter id="glow" x="-30%" y="-30%" width="160%" height="160%">
        <feDropShadow dx="0" dy="0" stdDeviation="6" flood-color="#FFFFFF" flood-opacity="1"/>
      </filter>
    </defs>

    <!-- The Dashed Flight Path Loop -->
    <path class="dashed-path" d="M -10 600 C 150 750, -50 750, 100 600 S 600 300, 1220 220" fill="none" stroke="#FDFFA2" stroke-width="8" stroke-dasharray="16 22"/>
    
    <!-- The Paper Airplane -->
    <image href="assets/images/da-plane.svg" x="1150" y="110" width="200" height="200" />
  </svg>

  <div class="dot-matrix"></div>
</div>

<!-- Options Section -->
<div class="options-section">
  <!-- Decorative Elements -->
  <svg class="decor-squiggle" viewBox="0 0 20 100" fill="none" stroke="#CED12A" stroke-width="4" stroke-linecap="round">
    <path d="M 15 5 Q 0 30 10 50 T 15 95" />
  </svg>
  
  <svg class="decor-lamp" viewBox="0 0 200 120" fill="none">
    <line x1="100" y1="0" x2="100" y2="40" stroke="#000086" stroke-width="3"/>
    <path d="M 20 100 L 180 100 L 100 40 Z" fill="#000086"/>
    <path d="M 85 100 Q 100 125 115 100 Z" fill="#CED12A"/>
  </svg>

  <div class="options-header">
    <h2 class="options-title">
      <svg class="decor-burst" viewBox="0 0 40 40" fill="none" stroke="#000086" stroke-width="4" stroke-linecap="round">
        <line x1="12" y1="28" x2="2" y2="15" />
        <line x1="20" y1="22" x2="12" y2="5" />
        <line x1="30" y1="18" x2="28" y2="2" />
      </svg>
      Self Direct Apply or Apply with an expert
    </h2>
    <p class="options-subtitle">Both options use the same universal application form. The difference is in how far we go to get you that offer.</p>
  </div>

  <div class="options-grid">
    <!-- Image Box -->
    <div class="video-placeholder" style="background: transparent; padding: 0; display: flex; align-items: center; justify-content: center; height: auto;">
      <img src="../../../assets/images/da-explanation.jpeg" alt="Direct Apply Explanation" style="max-width: 100%; height: auto; object-fit: contain;">
    </div>

    <!-- Self Apply Card -->
    <div class="option-card">
      <div class="oc-badge">SELF APPLY</div>
      <h3 class="oc-title">Apply yourself to the partner universities</h3>
      <p class="oc-desc">Apply directly to our network of vetted partner universities, with profile auto-fill and streamlined submissions.</p>
      <div class="oc-divider"></div>
      <ul class="oc-features">
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Apply to {{partnerUniversitiesCount}}+ partner universities</strong> directly with one profile</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Profile auto-fill</strong> — no re-entering details</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Reduced or waived</strong> application fees on select universities</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>One form</strong> covers every partner you pick</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Chat support</strong> whenever you feel stuck</div></li>
      </ul>
      <button class="oc-button" (click)="startStandardApply()">Browse partner universities &rarr;</button>
    </div>

    <!-- Expert Session Card -->
    <div class="option-card">
      <div class="oc-badge expert">EXPERT SESSION</div>
      <h3 class="oc-title">Apply yourself to the partner universities + 30 min session</h3>
      <p class="oc-desc">Apply directly to our network of vetted partner universities, with profile auto-fill and streamlined submissions.</p>
      <div class="oc-divider"></div>
      <ul class="oc-features">
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Apply to {{partnerUniversitiesCount}}+ partner universities</strong> directly with one profile</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Profile auto-fill</strong> — no re-entering details</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Reduced or waived</strong> application fees on select universities</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>One form</strong> covers every partner you pick</div></li>
        <li><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>Chat support</strong> whenever you feel stuck</div></li>
        <li class="highlight-feature"><i><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></i> <div><strong>A 30 min session</strong> with our premium counsellors</div></li>
      </ul>
      <button class="oc-button" (click)="startExpertApply()">Continue &rarr;</button>
    </div>
  </div>
</div>

<!-- Difference Section -->
<div class="difference-section">
  <!-- Decorative Elements -->
  <img src="assets/images/setting-icon.svg" class="decor-gears" alt="Gears decoration">
  
  <div class="difference-header">
    <h2 class="difference-title">Why Direct Apply is different ?</h2>
    <p class="difference-subtitle">Not just an application tool a commitment to getting you that offer letter.</p>
    
    <img src="assets/images/blub-icon.svg" class="decor-lightbulb" alt="Lightbulb decoration">
  </div>

  <div class="difference-grid">
    <!-- Card 1 -->
    <div class="diff-card">
      <div class="dc-icon"><img src="assets/images/glyphs_clock-fast-bold.svg" alt="Clock"></div>
      <div class="dc-content">
        <h3 class="dc-title">Accelerated turnaround</h3>
        <p class="dc-desc">Faster result notifications across your entire application pipeline. No waiting in the dark &mdash; you'll know sooner and act sooner when decisions come through.</p>
      </div>
    </div>

    <!-- Card 2 -->
    <div class="diff-card">
      <div class="dc-icon"><img src="assets/images/streamline-plump_customer-support-3-solid.svg" alt="Support"></div>
      <div class="dc-content">
        <h3 class="dc-title">Offer letter support</h3>
        <p class="dc-desc">We stand by your applications. If you don't secure an offer within your first 5 choices, we keep applying to more colleges on your behalf &mdash; you only cover the raw application fees.</p>
      </div>
    </div>

    <!-- Card 3 -->
    <div class="diff-card">
      <div class="dc-icon"><img src="assets/images/mdi_book-secure.svg" alt="Assurance"></div>
      <div class="dc-content">
        <h3 class="dc-title">GradPilots assurance</h3>
        <p class="dc-desc">Comprehensive application protection and full platform backing &mdash; every step of the way, from submission through to final decision. You're covered.</p>
      </div>
    </div>

    <!-- Card 4 -->
    <div class="diff-card">
      <div class="dc-icon"><img src="assets/images/mingcute_mic-ai-fill.svg" alt="Strategy"></div>
      <div class="dc-content">
        <h3 class="dc-title">Expert strategy session</h3>
        <p class="dc-desc">A free 30-minute expert counselling session and a step-by-step walkthrough with a dedicated consultant &mdash; included post-payment so you know exactly what comes next.</p>
      </div>
    </div>
  </div>
</div>

<!-- Admits Section -->
<div class="admits-section" #admitsSection>
  <!-- Background Blobs -->
  <div class="admits-bg">
    <img src="assets/images/side-pill.svg" class="side-pill left-pill" alt="">
    <img src="assets/images/side-pill.svg" class="side-pill right-pill" alt="">
  </div>
  
  <div class="admits-content">
    <h2>Admits across the world</h2>
    <p>Our students have received offer letters from top universities<br>across every major study destination. Here's where they're headed.</p>
    
    <div class="admits-grid">
      <div class="admit-card" *ngFor="let admit of admits">
        <div class="ac-flag"><img [src]="'assets/images/country-flags/' + admit.flag" [alt]="admit.alt"></div>
        <div class="ac-stats">{{ admit.count }}<span>{{ admit.suffix }}</span></div>
        <div class="ac-country">{{ admit.country }}</div>
        <div class="ac-unis">{{ admit.unis }}</div>
      </div>
    </div>
  </div>
</div>


<!-- Hear from the Students Section -->
<div class="testimonials-section w-full pt-8 pb-8 flex flex-column align-items-center relative z-1" style="background-color: #fff;">
    <div class="text-center relative inline-block mb-6">
        <h2 class="m-0 font-bold" style="color: #000086; font-size: clamp(40px, 4vw, 70px); font-family: 'Poppins', sans-serif;">
            Hear from the Students
        </h2>
        <div class="mx-auto mt-2" style="width: 184px; height: 6px; background-color: #D9DA5F; border-radius: 4px;"></div>
    </div>

    <!-- Horizontal Scrolling Container -->
    <div #testimonialContainer 
         class="w-full flex overflow-hidden gap-4 px-4 pb-5 pt-3" 
         style="white-space: nowrap;"
         (mouseenter)="pauseScroll()" 
         (mouseleave)="resumeScroll()">
        
        <div *ngFor="let t of extendedTestimonials" class="flex-shrink-0 relative border-round-3xl p-4 md:p-5 flex flex-column justify-content-between" 
             [style.background]="t.bgColor" 
             [style.border]="'2px solid ' + t.borderColor"
             style="width: 380px; min-height: 420px; white-space: normal;">
            
            <!-- Large Quote -->
            <div [style.color]="t.quoteColor" style="font-size: 60px; font-family: 'Lora', serif; line-height: 1; margin-top: 10px; font-weight: 700;">
                "
            </div>
            
            <!-- Testimonial Text -->
            <div class="flex-grow-1 mt-3 mb-4" style="color: #424242; font-size: 15px; line-height: 1.6; font-family: 'Sora', sans-serif;">
                {{t.text}}
            </div>

            <!-- Footer -->
            <div class="flex align-items-center justify-content-between w-full mt-auto pt-2">
                <!-- Avatar & Name -->
                <div class="flex align-items-center gap-3">
                    <div class="flex align-items-center justify-content-center border-circle" 
                         [style.background]="t.avatarColor" 
                         [style.color]="t.avatarTextColor"
                         style="width: 44px; height: 44px; font-size: 16px; font-weight: 800; font-family: 'Sora', sans-serif;">
                        {{t.avatarText}}
                    </div>
                    <div class="flex flex-column">
                        <span class="font-bold" style="color: #111111; font-size: 16px; font-family: 'Sora', sans-serif;">{{t.name}}</span>
                        <span style="color: #8E8E8E; font-size: 13px; font-family: 'Sora', sans-serif;">{{t.subtext}}</span>
                    </div>
                </div>

                <!-- Badge -->
                <div class="px-3 py-2 border-round-3xl flex align-items-center justify-content-center"
                     [style.background]="t.badgeBgColor"
                     [style.color]="t.badgeTextColor">
                    <span class="font-bold text-xs uppercase tracking-wide" style="font-family: 'Sora', sans-serif;">{{t.badgeText}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<app-clarity-call-popup
  [(visible)]="showClarityPopup"
  [contactPurpose]="ContactPurpose.DirectApplyContactUs"
  headline="Confused about your application process?<br>Let's sort it."
  bodyText="You don't have to figure out your application alone. Whether it's choosing universities, picking an apply option, or getting through the form — drop it here and we'll help you move forward."
  inputPlaceholder="Stuck on a step? Tell us here"
  ctaLabel="Get help">
</app-clarity-call-popup>


